(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-slider"] && !Shopify.designMode) return;
  try {
    
/* swiper CDN */
var script = document.createElement('script');
script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
document.head.appendChild(script);

script.onload = function () {
  const swiper = new Swiper(".custom-popular-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      10: { slidesPerView: 1.2 },
      540: { slidesPerView: 2.2 },
      900: { slidesPerView: 3 },
      1200: { slidesPerView: 4 },
    },
  });
};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
